// @ts-check

import { find, first, isEmpty } from "lodash";
import { DEFAULT_GRADIENT } from "src/consts/gradient";
import { firstPopulated } from "src/util/underscore";

/**
 * @param {{ src?: string }} img
 * @returns {boolean}
 */
const hasSrc = (img) => !isEmpty(img?.src);

/**
 * @param {{ tenantBranding?: org_config.tenant.Branding, workspaceBranding?: org_config.workspace.Branding }} branding
 * @returns {org_config.tenant.Branding & org_config.workspace.Branding}
 */
export const combineBranding = ({ tenantBranding, workspaceBranding } = {}) => {
  /** @type {string[]} */
  const gradients = firstPopulated(
    workspaceBranding?.gradients,
    tenantBranding?.gradients,
    [DEFAULT_GRADIENT]
  ) ?? [DEFAULT_GRADIENT];

  const gradient = first(gradients);
  const logoImage = find(
    [workspaceBranding?.logoImage, tenantBranding?.logoImage],
    hasSrc
  );

  return {
    appName:
      firstPopulated(
        workspaceBranding?.appName,
        tenantBranding?.appName,
        "TeamForm"
      ) ?? "TeamForm",
    gradients,
    ...(gradient !== undefined ? { gradient } : {}),
    ...(logoImage !== undefined ? { logoImage } : {}),
    stockImagesDisabled: !!tenantBranding?.stockImagesDisabled,
  };
};
